import React from 'react'
import { BCol, BRow } from '@prague-digi/ui-components'

import { IntlInterface, intl } from '../../../../hoc/'

interface Props extends IntlInterface {
  img: string
  msg: {
    text: string
    title: string
  }
}

export const Section = ({ img, msg, translate }: Props) => (
  <BRow theme="pb-4">
    <BCol theme="d-flex col-sm-auto pl-0 pr-0 justify-content-center" xs={12}>
      <img src={img} alt="icon" />
    </BCol>
    <BCol theme="col col-sm" xs={12}>
      <strong>{translate(msg.title)}</strong>
      <br />
      {translate(msg.text)}
    </BCol>
  </BRow>
)

export default intl(Section)
